import React from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css'; // Import SimpleBar CSS

const SimpleBarScrollbar = ({ children, style, ...props }) => {
  return (
    <SimpleBar
      style={{
        ...style, // Merge custom styles
      }}
      {...props} // Allow additional props to be passed
    >
      {children}
    </SimpleBar>
  );
};

export default SimpleBarScrollbar;
